import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';

// core components
import Card from '../md/components/Card/Card.jsx';
import CardBody from '../md/components/Card/CardBody.jsx';
import CardHeader from '../md/components/Card/CardHeader.jsx';

import loginPageStyle from '../assets/jss/crm/views/loginPageStyle.jsx';

import SuperAdminProfilePanel from '../components/SuperAdminProfilePanel';

class UserProfilePage extends React.Component {
  visibleErrorStyle = { color: 'red', visibility: 'visible', textAlign: 'center' };
  hiddenErrorStyle = { visibility: 'hidden' };

  constructor(props) {
    super(props);

    // we use cardAnimaton to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: 'cardHidden',
      email: '',
      password: '',
      unauthorized: true,
    };
  }

  componentDidMount() {
    const isKim = this.props.userInfo.email.startsWith('mccall.kim');
    this.setState({ unauthorized: !isKim });
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: '' });
      }.bind(this),
      700
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  render() {
    if (this.state.unauthorized) {
      return (
        <div>
          <h2>Sorry! You're not allowed to be here.</h2>;
          <h3>You need to be logged in as an AllevaRep or SuperAdmin.</h3>;
        </div>
      );
    }

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    const { classes, userInfo } = this.props;
    return (
      <div className={classes.container}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={6} md={4}>
            <form id="loginForm">
              <Card login className={classes[this.state.cardAnimaton]}>
                <CardHeader className={`${classes.cardHeader} ${classes.textCenter}`} color="allevaOrange">
                  <h4 className={classes.cardTitle}>Super Admin Password Changer</h4>
                </CardHeader>
                <CardBody>
                  <SuperAdminProfilePanel userInfo={userInfo} />
                </CardBody>
              </Card>
            </form>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
});
const actionProducers = {};
export default connect(mapStateToProps, actionProducers)(withStyles(loginPageStyle)(UserProfilePage));
